import { render, staticRenderFns } from "./SettingsTemplatesHelp.vue?vue&type=template&id=9eb10e44&scoped=true"
import script from "./SettingsTemplatesHelp.vue?vue&type=script&lang=js"
export * from "./SettingsTemplatesHelp.vue?vue&type=script&lang=js"
import style0 from "./SettingsTemplatesHelp.vue?vue&type=style&index=0&id=9eb10e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb10e44",
  null
  
)

export default component.exports